module["exports"] = [
  "#{street}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/address/street_name.js
 ** module id = 1024
 ** module chunks = 0
 **/